// Store configuration.
// Flip APPS_LIVE to true the moment the apps are approved & live — this reveals
// the "Now on iOS & Android" launch ribbon on the landing screen.
export const APPS_LIVE = false;

// Per-platform store links.
export const APP_STORE_URL = "https://bracednomore.store"; // Apple / App Store
export const PLAY_STORE_URL = "https://bracednomore.com"; // Google Play / Android
